import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import brandPortalOrdersbrandOrderTokenEdit from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/edit";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var EditOrderInformationIA = function EditOrderInformationIA(_ref) {
  var _context$brandOrder, _context$brandOrder$b;
  var context = _ref.context;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (brandOrderToken) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "ea0MKp",
      defaultMessage: [{
        "type": 0,
        "value": "To edit order information, first go to the "
      }, {
        "children": [{
          "type": 0,
          "value": "Order details page"
        }],
        "type": 8,
        "value": "OrderDetailsLinkFormatting"
      }, {
        "type": 0,
        "value": ". Then select the "
      }, {
        "children": [{
          "type": 0,
          "value": "Edit"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " link to make changes to shipping details, promotions or products."
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return EditOrderLinkFormatting(chunks, brandOrderToken);
        },
        OrderDetailsLinkFormatting: function OrderDetailsLinkFormatting(chunks) {
          return OrderLinkFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "V3/NqV",
      defaultMessage: [{
        "type": 0,
        "value": "You can edit the shipping address or ship date by clicking the pen icon next to the respective sections. After making your edits, click "
      }, {
        "children": [{
          "type": 0,
          "value": "Update"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " to save them. "
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "4Xj61v",
      defaultMessage: [{
        "type": 0,
        "value": "You can update product quantities by editing the "
      }, {
        "children": [{
          "type": 0,
          "value": "Qty"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " fields. You also apply or remove a promotion from the order as well."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "aQBXiZ",
      defaultMessage: [{
        "type": 0,
        "value": "When you make changes, you’ll have the option to leave a note for the retailer, which we highly recommend for a positive customer experience. The retailer will receive an email notification detailing the changes made."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "XGPsSb",
      defaultMessage: [{
        "type": 0,
        "value": "To edit order information for a new or unfulfilled order, first go to your "
      }, {
        "children": [{
          "type": 0,
          "value": "Orders"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": ", and navigate to the "
      }, {
        "children": [{
          "type": 0,
          "value": "order detail"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " page for the order you’d like to change. From there, select the "
      }, {
        "children": [{
          "type": 0,
          "value": "Edit"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " link to make changes to shipping details, promotions or products."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        },
        LinkFormatting: function LinkFormatting(chunks) {
          return OrderLinkFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "1Bp3jy",
      defaultMessage: [{
        "type": 0,
        "value": "You can edit the shipping address or ship date by clicking the pen icon next to the respective sections. After making your edits, click "
      }, {
        "children": [{
          "type": 0,
          "value": "Update"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " to save them. "
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "AXd4P9",
      defaultMessage: [{
        "type": 0,
        "value": "You can update product quantities by editing the "
      }, {
        "children": [{
          "type": 0,
          "value": "Qty"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " fields. You also apply or remove a promotion from the order as well."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "yD2687",
      defaultMessage: [{
        "type": 0,
        "value": "When you make changes, you’ll have the option to leave a note for the retailer, which we highly recommend for a positive customer experience. The retailer will receive an email notification detailing the changes made."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })));
  }
};
var EditOrderLinkFormatting = function EditOrderLinkFormatting(chunks, brandOrderToken) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrdersbrandOrderTokenEdit(brandOrderToken),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var OrderLinkFormatting = function OrderLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrders(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};